// Komponent nawigacji dni z kafelkami i opcją "wszystkie dni"

import React from "react";
import { useAccommodation } from "../../AccommodationProvider";

const DayNavigation: React.FC = () => {
  const {
    currentDayIndex,
    setCurrentDay,
    addToAllDays,
    toggleAddToAllDays,
    accommodationDays,
  } = useAccommodation();

  // Oblicz liczbę nocy (bez ostatniego dnia - checkout)
  const nightsCount = Math.max(0, accommodationDays.length - 1);

  // Helper function to format date and day name
  const formatDayInfo = (dayIndex: number) => {
    if (!accommodationDays[dayIndex]) {
      return { date: "", dayName: "" };
    }

    const dayData = accommodationDays[dayIndex];
    const date = new Date(dayData.date);

    const dayName = date.toLocaleDateString("pl-PL", { weekday: "short" });
    const dayMonth = date.toLocaleDateString("pl-PL", {
      day: "numeric",
      month: "numeric",
    });

    return {
      date: dayMonth,
      dayName: dayName.charAt(0).toUpperCase() + dayName.slice(1),
    };
  };

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      {/* Kafelki dni */}
      <div className="flex items-center gap-3">
        <div className="flex gap-2">
          {accommodationDays.slice(0, -1).map((_, index) => {
            const { date, dayName } = formatDayInfo(index);

            return (
              <button
                key={index}
                onClick={() => setCurrentDay(index)}
                className={`
                  px-3 py-2 rounded-lg font-medium text-xs transition-colors text-center min-w-[60px]
                  ${
                    currentDayIndex === index
                      ? "bg-blue-600 text-white"
                      : "bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200"
                  }
                `}
              >
                <div className="text-sm font-bold">{index + 1}</div>
                {date && (
                  <>
                    <div className="text-xs">{date}</div>
                    <div className="text-xs">{dayName}</div>
                  </>
                )}
              </button>
            );
          })}
        </div>
      </div>

      {/* Checkbox "Dodaj na wszystkie dni" */}
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={addToAllDays}
            onChange={toggleAddToAllDays}
            className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700">Dodaj na wszystkie dni</span>
        </label>

        {/* Licznik nocy */}
        <div className="flex items-center gap-1 text-sm text-gray-600 bg-gray-50 px-3 py-1 rounded-lg">
          <span>📊</span>
          <span className="font-medium">{nightsCount} noce</span>
        </div>
      </div>
    </div>
  );
};

export default DayNavigation;
